export default "__VITE_ASSET__BJxOzHTi__"